module.exports = __webpack_public_path__ + "static/waves-bottom-fd9c490ef760bd05c2895224e38e7e6f.png";